







import { Vue, Component } from 'vue-property-decorator';
import NewsList from '@/components/NewsList.vue';
import { OPTHINES } from './config';
import { Banner } from '@/components';
import { getBaseInfo } from './api/index';
@Component({
  components: {
    Banner,
    NewsList,
  },
})
export default class News extends Vue {
  option = OPTHINES;
  baseInfo = {};
  created() {
    getBaseInfo().then((res: any) => {
      this.$addPv(res.data.activityId);
      this.baseInfo = res.data;
    });
  }
}
